import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import type { Ref } from 'react';
import Breadcrumbs from '@/components/Breadcrumbs';
import { BreadcrumbListJsonLd } from '@/components/json-ld';
import { BreadcrumbItem } from '@/lib/breadcrumbs/types';
interface Props {
  items: BreadcrumbItem[];
  className?: string;
  withContainer?: boolean;
  ref?: Ref<HTMLDivElement>;
  wrapperClassName?: string;
}
const PageBreadcrumbs = t0 => {
  const $ = _c(18);
  const {
    items,
    className,
    withContainer: t1,
    ref,
    wrapperClassName
  } = t0;
  const withContainer = t1 === undefined ? true : t1;
  if (items.length <= 1) {
    return null;
  }
  let t2;
  if ($[0] !== items) {
    t2 = <BreadcrumbListJsonLd items={items} />;
    $[0] = items;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className || $[3] !== items) {
    t3 = <Breadcrumbs items={items} className={className} />;
    $[2] = className;
    $[3] = items;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const breadcrumbs = t4;
  if (!withContainer) {
    if (ref || wrapperClassName) {
      let t5;
      if ($[8] !== breadcrumbs || $[9] !== ref || $[10] !== wrapperClassName) {
        t5 = <div ref={ref} className={wrapperClassName}>{breadcrumbs}</div>;
        $[8] = breadcrumbs;
        $[9] = ref;
        $[10] = wrapperClassName;
        $[11] = t5;
      } else {
        t5 = $[11];
      }
      return t5;
    }
    return breadcrumbs;
  }
  let t5;
  if ($[12] !== wrapperClassName) {
    t5 = clsx("container", wrapperClassName);
    $[12] = wrapperClassName;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== breadcrumbs || $[15] !== ref || $[16] !== t5) {
    t6 = <div ref={ref} className={t5}>{breadcrumbs}</div>;
    $[14] = breadcrumbs;
    $[15] = ref;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default PageBreadcrumbs;